<template>
  <span style="text-align: left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <table border="0">
        <template v-for="(mod, modi) in content">
          <tr
            :key="'sec' + modi"
            v-if="
              (modi == 0 ||
                content[modi - 1].modulo.mod_secaomen !=
                  mod.modulo.mod_secaomen) &&
              hasAlgum(mod)
            "
          >
            <!-- style="background-color: #e2e2e2; text-align: right" -->
            <th colspan="10" style="border-bottom: 1px solid #fff1">
              {{ T("Seção") }} - {{ T(mod.modulo.mod_secaomen) }}&nbsp;
            </th>
          </tr>

          <tr
            :key="modi"
            v-if="
              row.master == null ||
              parents.filter(
                (v) => v.indexOf('|' + mod.modulo.mod_tabela + '--') === 0
              ).length > 0
            "
          >
            <th
              class="pl-2"
              @click="allline('|' + mod.modulo.mod_tabela + '--')"
            >
              {{ T(mod.modulo.mod_titulo) }}
            </th>
            <td>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--menu') !== -1
                "
                :label="T('Menu')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--menu']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--home') !== -1
                "
                :label="T('Cockpit')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--home']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--list') !== -1
                "
                :label="T('List')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--list']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--add') !== -1
                "
                :label="T('Add')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--add']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--edit') !== -1
                "
                :label="T('Edit')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--edit']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--del') !== -1
                "
                :label="T('Del')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--del']"
                :value="1"
              ></v-checkbox>
              <v-checkbox
                color="primary"
                class="left mr-3"
                v-if="
                  row.master == null ||
                  parents.indexOf('|' + mod.modulo.mod_tabela + '--view') !== -1
                "
                :label="T('View')"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--view']"
                :value="1"
              ></v-checkbox>

              <v-checkbox
                color="primary"
                class="left mr-3"
                v-for="(c, ci) of mod.custom"
                :key="ci"
                v-if="
                  row.master == null ||
                  parents.indexOf(
                    '|' + mod.modulo.mod_tabela + '--cs' + c.cus_pk
                  ) !== -1
                "
                :label="T('Ação ' + c.cus_pk)"
                @change="alterado()"
                hide-details
                v-model="map['|' + mod.modulo.mod_tabela + '--cs' + c.cus_pk]"
                :value="1"
              ></v-checkbox>

              <div v-if="getFlows(mod).flow" class="pa-2" style="clear: both">
                <v-checkbox
                  color="primary"
                  class="left mr-3"
                  v-for="(c, ci) of getFlows(mod).flow"
                  :key="ci"
                  v-if="
                    row.master == null ||
                    parents.indexOf(
                      '|' + mod.modulo.mod_tabela + '--flow_' + c.act
                    ) !== -1
                  "
                  :label="T(c.name)"
                  @change="alterado()"
                  hide-details
                  v-model="map['|' + mod.modulo.mod_tabela + '--flow_' + c.act]"
                  :value="1"
                ></v-checkbox>
              </div>

              <div
                v-if="getFlows(mod).flowaction"
                class="pa-2"
                style="clear: both"
              >
                <v-checkbox
                  color="primary"
                  class="left mr-3"
                  v-for="(c, ci) of getFlows(mod).flowaction"
                  :key="ci"
                  v-if="
                    row.master == null ||
                    parents.indexOf(
                      '|' + mod.modulo.mod_tabela + '--flowact_' + c.act
                    ) !== -1
                  "
                  :label="T(c.name)"
                  @change="alterado()"
                  hide-details
                  v-model="
                    map['|' + mod.modulo.mod_tabela + '--flowact_' + c.act]
                  "
                  :value="1"
                ></v-checkbox>
              </div>
            </td>
          </tr>
        </template>

        <tr>
          <!-- style="background-color: #e2e2e2; text-align: right" -->
          <th colspan="10" style="border-bottom: 1px solid #fff1">
            {{ T("Permissões específicas") }}&nbsp;
          </th>
        </tr>

        <tr v-for="(mod, modi) in specific" :key="'sp' + modi">
          <th class="pl-2" @click="allline(mod.modulo + '--' + mod.acao)">
            {{ T(mod.modulo + "/" + mod.acao) }}
          </th>
          <td>
            <v-checkbox
              color="primary"
              class="left mr-3"
              v-if="
                row.master == null ||
                parents.indexOf(mod.modulo + '--' + mod.acao) !== -1
              "
              :label="T(mod.modulo + '/' + mod.acao)"
              @change="alterado()"
              hide-details
              v-model="map[mod.modulo + '--' + mod.acao]"
              :value="1"
            ></v-checkbox>
          </td>
        </tr>
      </table>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <div :class="{ 'text-xs-center': crud.action == 'list' }">
        {{ value }}
      </div>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

import _ from "lodash";
export default {
  extends: _baseComponent,
  data() {
    return {
      content: [],
      map: {},
      specific: this.row._extra
        ? this.row._extra[this.campo.cmp_coluna][0].sort((a, b) => {
            if (a.modulo < b.modulo) return -1;
            if (a.modulo > b.modulo) return 1;
            if (a.acao < b.acao) return -1;
            if (a.acao > b.acao) return 1;
            return 0;
          })
        : [],
      parents:
        this.row._extra && this.row._extra[this.campo.cmp_coluna][1] != null
          ? this.row._extra[this.campo.cmp_coluna][1]
              .split(";")
              .filter((v) => !!v)
          : [],
    };
  },
  methods: {
    hasAlgum(mod) {
      return (
        this.content.find((f) => {
          return (
            f.modulo.mod_secaomen == mod.modulo.mod_secaomen &&
            (this.row.master == null ||
              this.parents.filter(
                (v) => v.indexOf("|" + f.modulo.mod_tabela + "--") === 0
              ).length > 0)
          );
        }) != null
      );
    },
    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
    alterado() {
      let ums = [];
      for (let x in this.map) {
        if (this.map[x] == 1) {
          ums.push(x);
        }
      }
      let txtfinal = ums.join(";");
      if (txtfinal != "") txtfinal += ";";

      console.log(txtfinal);
      this.$forceUpdate();
      this.$emit("input", this.preUpdate(txtfinal));
    },
    allline(prefix) {
      for (let x in this.map) {
        if (x.indexOf(prefix) != -1) {
          this.map[x] = this.map[x] == 1 ? null : 1;
        }
      }

      this.alterado();
    },
    getFlows(dbdef) {
      const temFluxo =
        dbdef.campos.filter((c) => c.cmp_coluna == "flowcontrol").length == 1;
      let flow, flowaction;
      if (temFluxo) {
        const myPk = dbdef.campos.filter((c) => c.cmp_pk == true)[0].cmp_coluna;

        let flows = dbdef.campos
          .filter((c) => c.cmp_coluna == "flowcontrol")[0]
          .cmp_valores.split(",")
          .map((v) => v.split(";"));
        let flowactions = dbdef.campos
          .filter((c) => c.cmp_coluna == "flowaction")[0]
          .cmp_valores.split(",")
          .map((v) => v.split(";"));

        flow = flows.map((v, i) => ({
          act: v[2],
          name: v[0],
          mode: v[1].toLowerCase(),
          n: i,
          k: myPk,
        }));
        flowaction = flowactions.map((v, i) => ({
          act: v[2],
          name: v[0],
          mode: v[1].toLowerCase(),
          n: i,
          k: myPk,
        }));
      }

      return { temFluxo, flow, flowaction };
    },
  },
  beforeMount() {
    let baselist = global.appmap_auto.dbdefs_active;

    for (let mod of baselist) {
      let js = require(`@/lib/dbdef/${mod}.json`);
      this.content.push(js);
    }

    this.content.sort((a, b) => {
      if (a.modulo.mod_secaomen < b.modulo.mod_secaomen) return -1;
      if (a.modulo.mod_secaomen > b.modulo.mod_secaomen) return 1;

      if (a.modulo.mod_sort < b.modulo.mod_sort) return -1;
      if (a.modulo.mod_sort > b.modulo.mod_sort) return 1;

      if (a.modulo.mod_titulo < b.modulo.mod_titulo) return -1;
      if (a.modulo.mod_titulo > b.modulo.mod_titulo) return 1;

      return 0;
    });

    if (this.parents) {
      for (let n of this.parents) {
        this.map[n] = null;
      }
    }

    if (this.value) {
      let p = this.value.split(";").filter((v) => !!v);
      for (let n of p) {
        if (this.row.master == null || this.parents.indexOf(n) !== -1)
          this.map[n] = 1;
      }
    }

    this.alterado();
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  /* border: dashed 1px #ccc; */
}
</style>
